import { useState, useRef, useMemo } from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { IDropdown } from './types';

const Dropdown = (props: IDropdown) => {
  const { options, inputLabel, width = 200, onChange, value, onBlur, disabled = false, padding, isMultiSelect = false } = props;
  const selectedValue = isMultiSelect ? value || [] : (value ?? '');
  const [isHovered, setIsHovered] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);
  const labelId = useMemo(() => (inputLabel ? `${inputLabel.replace(/\s+/g, '-').toLowerCase()}-label` : 'dropdown-label'), [inputLabel]);
  const selectId = `${labelId}-select`;

  return (
    <Box sx={{ width }}>
      <FormControl variant="outlined" fullWidth>
        <InputLabel id={labelId} sx={{ pl: padding || '15px', fontWeight: 400 }}>
          {inputLabel}
        </InputLabel>
        <Select
          ref={selectRef}
          labelId={labelId}
          id={selectId}
          value={selectedValue}
          onChange={onChange}
          disabled={disabled}
          multiple={isMultiSelect}
          open={isHovered}
          onClose={() => setIsHovered(false)}
          onOpen={() => setIsHovered(true)}
          onBlur={onBlur}
          label={inputLabel}
          renderValue={(selected) => {
            if (isMultiSelect) {
              const selectedArray = Array.isArray(selected) ? selected : [selected];
              return selectedArray.join(', ');
            }
            return selected as string;
          }}
        >
          {options.map((option) => (
            <MenuItem key={option.id} value={option.optionValue}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

Dropdown.defaultProps = {
  options: [
    { id: 1, label: 'Twenty', optionValue: 20 },
    { id: 3, label: 'Thirty', optionValue: 30 },
  ],
  inputLabel: 'Age',
} as Partial<IDropdown>;

export default Dropdown;
